import { Directive, ElementRef,  OnInit } from '@angular/core';

@Directive({
  selector: '[phoneNumber]'
})
export class PhoneNumberDirective implements OnInit{ 
  
  constructor(private el: ElementRef) {
  }

  ngOnInit(): void {
    const elem = this.el.nativeElement;
    elem.addEventListener('keydown', (evt) => ["e", "E", "+", "-", "."].includes(evt.key) && evt.preventDefault());

    elem.addEventListener("paste", (event) => {
      event.preventDefault();

      let paste = (event.clipboardData).getData('text');
      paste = paste.replace(/[e\+\-\.]/gi, "");
      this.el.nativeElement.value = paste;
    });
  }

}